export default __webpack_public_path__ + "static/media/one_file.1c2133f5.png";